export const formatNumberWithSpaces = (number) => {
  if (isNaN(number)) return number;

  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
